import { useQuery } from "react-query";
import { EMPTY_THERMOCOUPLE_SETTING } from "shared/helpers/thermocoupleCache";







export const thermocoupleSettingKey = (machine) => ["thermocoupleSetting", machine];



export const useReceivedThermocoupleSetting = (machine) => {
  const { data } = useQuery(thermocoupleSettingKey(machine), {
    enabled: false,
  });
  return data || EMPTY_THERMOCOUPLE_SETTING;
};
